import React from "react";

import { PurchasedList } from "../../../components/admin/u1/purchased/PurchasedList";
import { PurchaseBadge } from "../../../components/admin/u1/purchased/PurchaseBadge";
import { IN_PROGRESS, OPEN, EXPIRED } from "../../../components/admin/u1/purchased/purchasedState";
import { StateLegend } from "../../../components/common/static/u1/StateLegend";
import { ResearcherCard } from "../../../components/common/static/u1/ResearcherCard";
import "../../../components/common/u1/tokens.css";

/* u1 Purchased — TIP-641.
 *
 * Visual uplift only. The list's data handling is transcribed in
 * PurchasedList; the rail reuses the shared StateLegend, carrying purchase
 * pills instead of profile badges, and the researcher card the other dashboard
 * screens already have.
 */

/* The legend's three steps are the same three states the rows draw, and both read them from the same module — so the sidebar cannot describe a state the list... */
export const PURCHASE_STEPS = [
  {
    id: OPEN,
    tone: "success",
    badge: <PurchaseBadge state={OPEN} />,
    copy: "The business was already Claimed or Verified, so its Web Profile exists and opens for review the moment you pay. A finished report opens the same way.",
  },
  {
    id: IN_PROGRESS,
    tone: "warning",
    badge: <PurchaseBadge state={IN_PROGRESS} />,
    copy: "The business had not been claimed or verified, so there was nothing to open. The TREVEX analyst team gathers the information and delivers it. We notify you when the Web Profile is ready.",
  },
  {
    id: EXPIRED,
    tone: "muted",
    badge: <PurchaseBadge state={EXPIRED} />,
    copy: "Your viewing period on that company profile has ended. Renew access to open it again.",
  },
];

export default function Purchased() {
  return (
    <div className="u1-root grid grid-cols-1 items-start gap-[22px] py-6 lg:grid-cols-[minmax(0,1fr)_340px]">
      <PurchasedList />

      <aside className="flex min-w-0 flex-col gap-4">
        <StateLegend
          eyebrow="Reading your purchases"
          title="What happens after you order"
          intro="One order, three states. Which one you land on depends on whether the business had already been claimed or verified."
          steps={PURCHASE_STEPS}
          /* Membership is beside the point here — this card describes orders. */
          showMembershipNote={false}
        />
        <ResearcherCard />
      </aside>
    </div>
  );
}
